import React, { ReactNode } from "react";

import { Modal, Spinner } from "@samskip/frontend-components";

interface LoadingModalProps {
  isOpen: boolean;
  children: ReactNode;
}

const LoadingModal = ({ isOpen, children }: LoadingModalProps) => (
  <Modal corner="sharp" open={isOpen}>
    <div className="flex flex-col items-center justify-center gap-4">
      <p className="text-neutral-900">{children}</p>
      <Spinner />
    </div>
  </Modal>
);

export default LoadingModal;
